import { HomeData } from '@practium/features/home';

export const farmerHomeMockData: HomeData = {
	user: {
		name: 'Maria',
		type: 'Agricultor',
		plan: 'Professional',
	},

	carousel: [
		{
			id: '1',
			title: 'Conheça nosso treinamento completo para cadeia produtiva do café.',
			buttonText: 'Saber mais',
			buttonLink: '/saber-mais',
			imageUrl: '/images/carousel-slide-1.jpg',
		},
		{
			id: '2',
			title: 'Sua recomendação de adubação para o Café está pronta',
			buttonText: 'Acessar Plano',
			buttonLink: '/recomendacoes/planos',
			imageUrl: '/images/carousel-slide-2.jpg',
		},
		{
			id: '3',
			title: 'Mantenha o cadastro das suas áreas e setores atualizado',
			buttonText: 'Gerenciar Propriedade',
			buttonLink: '/propriedades',
			imageUrl: '/images/carousel-slide-3.jpg',
		},
	],

	actionCards: [
		{
			id: 'flora-ai',
			title: 'Flora AI',
			subtitle: 'Tem alguma dúvida? Converse com a Flora, nossa IA especialista',
			buttonText: 'Falar agora',
			buttonLink: '/flora-ai',
			variant: 'flora',
		},
		{
			id: 'analises',
			title: 'Minhas Análises',
			subtitle: 'Realize com facilidade suas análises de solo e folha',
			buttonText: 'Nova Análise',
			buttonLink: '/analises',
			variant: 'applications',
		},
		{
			id: 'dashboard',
			title: 'Dashboard',
			subtitle: 'Não consegue visualizar? Veja agora a evolução da sua operação',
			buttonText: 'Ver agora',
			buttonLink: '/dashboard',
			variant: 'dashboard',
		},
	],

	calendar: {
		currentMonth: 'Janeiro',
		currentYear: 2026,
		events: [
			{
				id: '1',
				title: 'Aplicação de Calcário',
				description: 'Talhão do Café - Conforme recomendação #402',
				date: '2026-01-15',
				type: 'manejo',
				icon: '🚜',
				color: 'var(--primary)',
			},
			{
				id: '2',
				title: 'Coleta de Amostra Foliar',
				description: 'Setor 02 - Preparação para pós-colheita',
				date: '2026-01-18',
				type: 'analise',
				icon: '🍃',
				color: 'var(--primary)',
			},
			{
				id: '3',
				title: 'Visita do Consultor',
				description: 'João Agrônomo - Avaliação visual',
				date: '2026-01-22',
				type: 'visita',
				icon: '👨‍🌾',
				color: 'var(--primary)',
			},
			{
				id: '4',
				title: 'Início Previsto da Colheita',
				description: 'Talhão 01',
				date: '2026-01-28',
				type: 'colheita',
				icon: '☕',
				color: 'var(--primary)',
			},
		],
		selectedPeriod: {
			start: '2026-01-15',
			end: '2026-01-22',
		},
	},

	history: [
		{
			id: '1',
			action: 'Análise de solo cadastrada',
			department: 'Análises',
			date: '10/05/2026',
			status: 'Em breve',
			createdAt: '2026-05-10T11:00:00Z',
		},
		{
			id: '2',
			action: 'Ticket de suporte aberto',
			department: 'Suporte',
			date: '08/05/2026',
			status: 'Em breve',
			createdAt: '2026-05-08T15:30:00Z',
		},
		{
			id: '3',
			action: 'Nova área "Pomar Novo" criada',
			department: 'Propriedades',
			date: '06/05/2026',
			status: 'Concluído',
			createdAt: '2026-05-06T09:45:00Z',
		},
		{
			id: '4',
			action: 'Recomendação visualizada',
			department: 'Recomendações',
			date: '05/05/2026',
			status: 'Concluído',
			createdAt: '2026-05-05T14:20:00Z',
		},
	],

	planInfo: {
		name: 'Professional',
		expirationDate: '07/09/26',
		upgradeMessage: 'Desbloqueie análises ilimitadas e suporte prioritário com o plano Premium!',
	},
};
